import React from 'react'
import { useStateContext } from '../context/stateContext';
import {data} from '../utils/data';

const Footer = () => {
  const {lightTheme} = useStateContext();

  return (
    <footer className={`footer ${lightTheme?"light":"dark"}`}>
      Made With <i className="fa-solid fa-heart"></i> By {data.firstName} <span>&copy;</span>
    </footer>
  )
}

export default Footer
